<div class="col-md-12 d-inline-flex mb-4">
    <div [formGroup]="group">
        <label style="font-size: 13px;font-weight: 600;">{{field.label}}</label> 
        <label>*</label>
        <div *ngFor="let v of field.options" class="inline-form-group">
          <label class="cust-check-bx">
            <input [ngClass]="{'disabled': field.disabled}" [disabled]="field.disabled" type="checkbox" [value]="v.value" [formControlName]="v.label" name="{{v.label}}"> {{v.label}}
            <span class="checkmark"></span>
          </label>
        </div>
    </div>
  </div> 